export default {
  hints: {
    recover: 'Забыли пароль?'
  },

  buttons: {
    reset: 'Сбросить',
    request: 'Запросить'
  }
}
